// Styles
import './CardModal.css'
import { useState, useEffect } from 'react'

const CardModal = ({ isOpen, onClose, onSave, card, apiError }) => {
    const [fields, setFields] = useState({ title: '', description: '' })
    const [touched, setTouched] = useState({})

    useEffect(() => {
        if (isOpen) {
            setFields(card
                ? { title: card.title, description: card.description }
                : { title: '', description: '' }
            )
            setTouched({})
        }
    }, [card, isOpen])

    if (!isOpen) return null

    const validations = {
        title: (v) => {
            if (!v || !v.trim()) return 'O título do card é obrigatório.'
            if (/^\s*$/.test(v)) return 'O título não pode consistir apenas em espaços em branco.'
            if (v.trim().length < 3) return 'O título deve ter entre 3 e 100 caracteres.'
            if (v.trim().length > 100) return 'O título deve ter entre 3 e 100 caracteres.'
            return null
        }
    }

    const errors = {
        title: validations.title(fields.title)
    }

    const isFormValid = Object.values(errors).every(e => e === null)

    const handleChange = (e) => {
        setFields(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleBlur = (e) => {
        setTouched(prev => ({ ...prev, [e.target.name]: true }))
    }

    const handleSave = () => {
        setTouched({ title: true })
        if (!isFormValid) return
        onSave(fields)
    }

    return (
        <div className='CardModal-overlay' onClick={onClose}>
            <div className='CardModal' onClick={e => e.stopPropagation()}>
                <div className='CardModal-header'>
                    <h2>{card ? 'Editar Card' : 'Novo Card'}</h2>
                    <button className='CardModal-close' onClick={onClose}>✕</button>
                </div>
                <div className='CardModal-body'>

                    {/* ── Erro da API ─────────────────────────────────────── */}
                    {apiError &&
                        <div className='CardModal-api-error'>{apiError}</div>
                    }
                    {/* ──────────────────────────────────────────────────────── */}

                    <div className='CardModal-field'>
                        <label>Título</label>
                        <input
                            name='title'
                            type='text'
                            placeholder='Título do card'
                            value={fields.title}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {touched.title && errors.title &&
                            <span className='CardModal-field-error'>{errors.title}</span>
                        }
                    </div>
                    <div className='CardModal-field'>
                        <label>Descrição <span className='CardModal-optional'>(opcional)</span></label>
                        <textarea
                            name='description'
                            placeholder='Descreva o card...'
                            value={fields.description}
                            onChange={handleChange}
                            rows={4}
                        />
                    </div>
                </div>
                <div className='CardModal-footer'>
                    <button className='CardModal-btn-cancel' onClick={onClose}>Cancelar</button>
                    <button
                        className='CardModal-btn-save'
                        onClick={handleSave}
                        disabled={!isFormValid}
                    >
                        {card ? 'Salvar' : 'Criar'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CardModal